<template>
  <v-layout
    v-if="user"
    row
    align-center
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
          <page-title :title="$t('my_vouchers')" />
          <div
            v-if="voucherList && voucherList.length > 0"
            class="mt-2 mb-2"
          >
            <v-card
              v-for="(voucher, index) in voucherList"
              :key="voucher.id"
              style="border-radius: 5px; margin-bottom: 18px;"
              :color="theme.address_bg_color"
              class="pointer"
              @click="voucherAction(voucher)"
            >
              <v-layout
                row
                pt-2
                pb-1
              >
                <v-flex xs6>
                  <v-img
                    tile
                    height="80"
                    :src="voucher.image"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex xs6>
                  <v-card-title class="pt-0 pb-0">
                    <v-layout row>
                      <v-flex xs12>
                        <h4 :style="cardTitleStyle">
                          {{ voucher.name }}
                        </h4>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text
                    class="pb-1"
                    v-if="voucher.expiry_date && voucher.expiry_date !== '0000-00-00 00:00:00'"
                    :style="cardTextStyle">
                    <v-layout
                      row
                      pt-2
                      pb-1
                    >
                      <span style="font-size: smaller;">Valid till: {{ formatDate(voucher.expiry_date) }}</span>
                    </v-layout>
                  </v-card-text>
                  <v-card-text class="pb-1" v-if="voucher.used && voucher.gems_member_voucher.UnlimitedUse !== 1" :style="cardTextStyle">
                    <v-layout
                      row
                      pt-2
                      pb-1
                    >
                      <span style="font-size: smaller;">Used: {{ formatDate(voucher.used) }}</span>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <div
            v-else
            class="mt-2 mb-2"
            :style="nameStyle"
          >
            {{ $t('none') }}
          </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Form from 'vform'
import PageTitle from '~/components/PageTitle'
import moment from 'moment'

export default {
  name: 'my-voucher-view',
  metaInfo () {
    return { title: this.$t('profile') }
  },
  components: {
    'page-title': PageTitle
  },
  data: () => ({
    busy: false,
    voucherList: {
      type: Object,
      default: () => null
    }
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'pictures', 'colors'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('member', [
      'points', 'profile', 'membership', 'membershipConfig'
    ]),
    ...mapGetters('voucher', [
      'vouchers'
    ]),
    defaultUserImg () {
      return this.pictures + 'user.svg'
    },
    myImg () {
      return this.user && this.user.photo ? this.user.photo : window.config.sharedPictures + 'user.svg'
    },
    form () {
      return new Form({
        name: this.user.name,
        name2: this.user.name2
      })
    },
    loginMethod () {
      return this.user.social ? this.user.social : 'Email'
    },
    titleStyle () {
      return {
        fontSize: '20px',
        color: this.theme.orders_title_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    myContainerStyle () {
      return {
        padding: '13px 15px'
      }
    },
    myMenuStyle () {
      return {
        position: 'relative',
        marginLeft: '1px',
        marginRight: '1px',
        borderRadius: '4px',
      }
    },
    cardTitleStyle () {
      return {
        color: this.theme.address_text_color,
        fontWeight: 800
      }
    },
    cardTextStyle () {
      return {
        paddingTop: '0',
        color: this.theme.address_text_color
      }
    },
    myUsedStyle () {
      return {
        // border: `1px solid ${this.theme.menu_price_color}`,
        // borderRadius: '4px',
        textAlign: 'center',
        position: 'absolute',
        fontSize: 'large',
        color: 'red',
        zIndex: '9'
      }
    },
  },
  methods: {
    async save () {
      if (await this.formHasErrors()) return
      this.busy = true

      try {
        // Register the user.
        await this.$store.dispatch('auth/updateProfile', this.form)
        this.busy = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Changes to your profile were saved'
        })
      } catch (e) {
        this.busy = false
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Failed to update user profile',
          modal: true
        })
      }
    },
    formatDate (date) {
      // const d = new Date(date)
      const d = moment(date)
      return d.format('YYYY-MM-DD')
      // const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      // const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      // return d.getFullYear() + '-' + month + '-' + day
    },
    voucherAction (voucher) {
      this.$router.push({ name: 'voucher', params: { id: voucher.id.toString() }})
      // if (parseInt(voucher.gems_member_voucher.VoucherType) === 0) {
      //   this.$router.push({ name: 'voucher', params: { id: voucher.id.toString() }})
      // } else if (voucher.gems_member_voucher.PLUID && voucher.item) {
      //   this.$store.dispatch('voucher/setPromotionVoucher', voucher)
      //   this.$store.dispatch('voucher/showPromotionDialog')
      //   this.$router.push({ name: 'menu' })
      //   if (this.iOS && this.inIframe) {
      //     this.$router.push({ name: 'promotion', params: { return: 'menu' } })
      //   }
      // }
    }
  },
  async created () {
    await this.$store.dispatch('voucher/fetchMyVouchers')
    this.voucherList = this.vouchers.filter(v => {
      return (v.gems_member_voucher.VoucherType === 0 || v.gems_member_voucher.VoucherType === 1)
    })
    this.voucherList.sort(function(a, b) {
      let keyA = new Date(a.created),
        keyB = new Date(b.created);
      // Compare the 2 dates
      if (keyA > keyB) return -1;
      if (keyA < keyB) return 1;
      return 0;
    })
    await this.$store.dispatch('auth/fetchUser')
    const dict = {
      custom: {
        name: {
          required: 'Please enter your first name / given name'
        },
        name2: {
          required: 'Please enter your last name / family name'
        },
        mobile: {
          required: 'Please enter your mobile number'
        },
        birthday: {
          required: 'Please enter your birthday'
        }
      }
    }
    this.$validator.localize('en', dict)
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
.pointer {
   cursor: pointer;
   position: relative;
 }
.used-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.4);
  color: white;
  z-index: 1;
}
.used-text {
  font-size: 18px;
  color: white;
  background-color: #e34f4f;
  padding: 3px 8px 3px 8px;
  transform: rotate(-5deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/my_vouchers.vue